import { Dimensions } from '~/jobiqo/lib/analytics';
import { User } from '~/jobiqo/models/user';
import { SearchApiJobResult } from '~/jobiqo/types/types';
import { Facet } from '~/jobiqo/models/search';

/**
 * Returns the custom dimensions for a given organization profile search.
 *
 * Can be used to add custom dimensions to the analytics event for organization profile search.
 *
 * @param {User | null} user
 *   The current user.
 * @param {SearchApiJobResult} organizationProfiles
 *   Organization profile search API result.
 * @param {string} title
 *   Search title.
 * @param {Facet[]} selectedFacets
 *   Selected facets on the organization profile search page.
 * @param {string} location
 *   Organization profile search location.
 * @param {string} [searchQuery]
 *   The search query.
 * @returns {Dimensions}
 *   The custom dimensions object for this organization profile search.
 */
export const getCustomOrganizationProfileSearchDimensions = (
  user: User | null = null,
  organizationProfiles: SearchApiJobResult,
  title: string,
  selectedFacets: Facet[],
  location: string,
  searchQuery?: string,
): Dimensions => {
  return {};
};
